module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(!_vm.nodata) ? _c('div', [_c('h2', {
    staticClass: "title",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })]) : _c('div', {
    staticClass: "nodata"
  }, [_c('img', {
    attrs: {
      "width": "100",
      "src": require("../assets/image/nomsg.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂无相关信息")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cb554ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/featureIntro.vue
// module id = 226
// module chunks = 1